import { DeleteOutlined, LockOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import Workspace from '../../types/Workspace';

export enum SpaceStatus {
  NotFound = 'notFound',
  Forbidden = 'forbidden',
  Loading = 'loading',
  Loaded = 'loaded',
}

type SpaceStatusContentProps = {
  spaceStatus: SpaceStatus;
  space: Workspace | undefined;
  onNavigateHome: () => void;
  children?: React.ReactNode;
};

export const SpaceStatusContent: React.FC<SpaceStatusContentProps> = ({
  spaceStatus,
  space,
  onNavigateHome,
  children,
}) => {
  if (spaceStatus === SpaceStatus.Forbidden) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 align-middle mt-[36vh]">
        <div className="flex items-center justify-center w-[46px] h-[46px] bg-yellow-100 rounded-full">
          <LockOutlined className="text-yellow-600" />
        </div>
        <div className="text-neutral-900 text-sm font-medium leading-tight">
          You don't have access to this space.
        </div>
        <Button
          className="text-neutral-900 text-base font-semibold"
          type="default"
          onClick={onNavigateHome}
        >
          Go to Home
        </Button>
      </div>
    );
  }

  if (spaceStatus === SpaceStatus.NotFound) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 align-middle mt-[36vh]">
        <div className="flex items-center justify-center w-[46px] h-[46px] bg-red-100 rounded-full">
          <DeleteOutlined className="text-red-400" />
        </div>
        <div className="text-neutral-900 text-sm font-medium leading-tight">
          This space has been deleted.
        </div>
        <Button
          className="text-neutral-900 text-base font-semibold"
          type="default"
          onClick={onNavigateHome}
        >
          Go to Home
        </Button>
      </div>
    );
  }

  if (spaceStatus === SpaceStatus.Loaded) {
    if (!space) {
      return <div></div>;
    }
    return <>{children}</>;
  }

  if (spaceStatus === SpaceStatus.Loading) {
    return <></>;
  }

  return <div>Not Supported</div>;
};
